import { Button } from 'primereact/button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import 'date-fns';
// import { useFormik } from "formik";
import * as React from 'react';
// import { MemberService } from '../../../remote-api/api/member-services';
// import { ClientTypeService, PlanService } from '../../../remote-api/eo2v2-remote-api';
import { Box } from '@material-ui/core';

// const memberservice = new MemberService();
// const planservice = new PlanService();
// const clienttypeervice = new ClientTypeService();

export default function InstallmentModal({ showComponentInstallment, setShowComponentInstallment }) {
  const [openInstallment, setOpenInstallment] = React.useState(false);
  const [customInstallment, setCustomInstallment] = React.useState([
    {
      amount: '',
      commission: '',
      stampDuty: '',
      taxAmount: '',
      paidAmount: '',
      date: new Date().toISOString().substring(0, 10),
    },
  ]);

  const emptyInstallment = {
    amount: '',
    commission: '',
    stampDuty: '',
    taxAmount: '',
    paidAmount: '',
    date: new Date().toISOString().substring(0, 10),
  };

  const handleAddInstallment = () => {
    setCustomInstallment(prev => [...prev, { ...emptyInstallment }]);
  };

  const handleRemoveInstallment = indexToRemove => {
    const updatedList = customInstallment.filter((_, idx) => idx !== indexToRemove);
    setCustomInstallment(updatedList);
  };

  const updateField = (index, field, value) => {
    setCustomInstallment(prevState => {
      const updated = [...prevState];
      updated[index] = { ...updated[index], [field]: value };

      // Force non-first Stamp Duty to "0.00"
      if (field === 'stampDuty' && index !== 0) {
        updated[index][field] = '0.00';
      }

      return updated;
    });
  };

  const handleSubmitInstallments = () => {
    const quotationId = localStorage.getItem('quotationId');
    const { customInstallment } = this.state;

    const payload = customInstallment.map(inst => ({
      quotationId: null,
      installmentId: null,
      instalmentAmount: parseFloat(inst.amount) || 0,
      commision: parseFloat(inst.commission) || 0,
      paidAmount: parseFloat(inst.paidAmount) || 0,
      totalBalance: parseFloat(inst.paidAmount) || 0,
      stampDuty: parseFloat(inst.stampDuty) || 0,
      tax: [
        {
          value: parseFloat(inst.taxAmount) || 0,
          effectiveFrom: new Date(inst.date).getTime(),
          effectiveUpto: null,
          orgTypeCd: null,
          parentTaxId: null,
          sortOrder: null,
          isRefundable: null,
          name: null,
          type: null,
          id: null,
        },
      ],
    }));

    // quotationService.saveInstallment(quotationId, payload).subscribe(res => {
    //   console.log(res);
    // });
  };
  const handleClose = () => {
    setShowComponentInstallment(false);
  };

  const formatDate = ms => {
    const date = new Date(ms);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Dialog open={showComponentInstallment} fullWidth={false} maxWidth="lg" aria-labelledby="form-dialog-title">
      {/* <DialogTitle id="form-dialog-title"> Installment </DialogTitle> */}
      <Box p={2}>
        {/* <Table size="small" sx={{ minWidth: 650 }} aria-label="installment summary table">
          <TableHead>
            <TableRow>
              <TableCell>Sl#</TableCell>
              <TableCell>Installment Amount</TableCell>
              <TableCell>Commission</TableCell>
              <TableCell>Stamp Duty</TableCell>
              <TableCell>Tax</TableCell>
              <TableCell>Paid Amount</TableCell>
              <TableCell>Installment Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {instalmentData?.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.instalmentAmount}</TableCell>
                <TableCell>{row.commision}</TableCell>
                <TableCell>{row.stampDuty}</TableCell>
                <TableCell>{row.tax[0]?.value}</TableCell>
                <TableCell>{row.paidAmount}</TableCell>
                <TableCell>{formatDate(row.tax[0]?.effectiveFrom)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table> */}
      </Box>
      <Box style={{ marginTop: '1rem' }}>
        <DialogContent>
          {customInstallment.map((row, idx) => (
            <Grid container spacing={2} alignItems="center" key={idx} style={{ marginBottom: '8px' }}>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Installment Amount"
                  value={row.amount}
                  onChange={e => updateField(idx, 'amount', e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Commission"
                  value={row.commission}
                  onChange={e => updateField(idx, 'commission', e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Stamp Duty"
                  // value={row.stampDuty}
                  value={idx === 0 ? row.stampDuty : '0.00'}
                  // onChange={e => props?.updateField(idx, 'stampDuty', e.target.value)}
                  onChange={e => updateField(idx, 'stampDuty', e.target.value)}
                  disabled={idx !== 0}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Tax Amount"
                  value={row.taxAmount}
                  onChange={e => updateField(idx, 'taxAmount', e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Paid Amount"
                  value={row.paidAmount}
                  onChange={e => updateField(idx, 'paidAmount', e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="Installment Date"
                  value={row.date}
                  InputLabelProps={{ shrink: true }}
                  onChange={e => updateField(idx, 'date', e.target.value)}
                />
              </Grid>

              {/* Remove button */}
              <Grid item xs={12} container justifyContent="flex-end">
                {customInstallment.length > 1 && (
                  <Tooltip title="Remove">
                    <Button variant="contained" color="secondary" onClick={() => handleRemoveInstallment(idx)}>
                      <DeleteIcon />
                    </Button>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
          ))}
          <Grid container justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={handleAddInstallment}>
              <AddIcon /> Add More
            </Button>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button color="secondary" onClick={handleSubmitInstallments}>
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
